import { Injectable } from "@angular/core";
import { Setting } from "../setting";
import { BaseService } from "./base.services";

@Injectable({
  providedIn: "root",
})
export class OrganizationService {
  constructor(
    public setting: Setting,
    public baseService: BaseService<any>
  ) {}

getOrganizations(): Promise<any> {
    let promisse = new Promise((resolve, reject) => {
      this.baseService.get(this.setting.Endpoint.Organizations).subscribe({
            next: (response) => {
               resolve(response);
            },
            error: (error) => {
              reject(error);
            }
        });
    })
    
    return promisse;
}

createOrganization(org:any): Promise<any> {
  let promisse = new Promise((resolve, reject) => {
    this.baseService.post(this.setting.Endpoint.Organizations,org).subscribe({
          next: (response) => {
             resolve(response);
          },
          error: (error) => {
            reject(error);
          }
      });
  })
  
  return promisse;
}

}

